import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { ReadyRollset } from "../models/Rolllset";

type getReadyRollsetsProps = {
	standId?: number | null;
	sectionId?: number | null;
	rollsetId?: number | null;
};

export const getReadyRollsets = async (
	params: getReadyRollsetsProps,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SectionId", value: params.sectionId ?? null },
	];

	if (params.standId) {
		parameters.push({ name: "StandId", value: params.standId });
	}

	if (params.rollsetId) {
		parameters.push({ name: "RollsetId", value: params.rollsetId });
	}

	const resp = await apiService.callV2(
		"[M2].[GetReadyRollsets]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as ReadyRollset[];
	} else {
		throw new Error(resp.message || "Error fetching ready rollsets");
	}
};

type upsertRollsetProps = {
	standId: number;
	sectionId: number;
	rollsetLetter: string;
	topRollId?: number | null;
	bottomRollId?: number | null;
	sourceCode?: "M" | "R"; // M=Mill, R=Rollshop
	actionTypeCode?: "S" | "M" | "C"; // S=Swap, M=Mix, C=Create
};

export const upsertRollset = async ({
	standId,
	sectionId,
	rollsetLetter,
	topRollId,
	bottomRollId,
	sourceCode = "M", // Default to Mill (carrier assembly context)
	actionTypeCode = "C", // Default to Create
}: upsertRollsetProps) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "StandId", value: standId },
		{ name: "SectionId", value: sectionId },
		{ name: "RollsetLetter", value: rollsetLetter },
		{ name: "SetAsInactive", value: false },
		{ name: "SourceCode", value: sourceCode },
		{ name: "ActionTypeCode", value: actionTypeCode },
	];

	if (topRollId != null) {
		parameters.push({ name: "TopRollId", value: topRollId });
	}
	if (bottomRollId != null) {
		parameters.push({ name: "BottomRollId", value: bottomRollId });
	}

	const resp = await apiService.callV2("[M2].[UpsertRollset]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue") as number;
	} else {
		throw new Error(resp.message || "Error creating rollset");
	}
};
